import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import * as dayjs from "dayjs";
@Component({
  selector: "app-data-revisions-dropdown",
  templateUrl: "./data-revisions-dropdown.component.html",
  styleUrls: ["./data-revisions-dropdown.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DataRevisionsDropdownComponent implements OnInit {
  checkOptions = [
    { label: "Values", value: "values", checked: false },
    { label: "Δ Delta", value: "revision", checked: false },
    { label: "YoY%", value: "yoy", checked: false },
  ];
  radioValue = "";
  prevRadioValue = "";
  inValidCustomDate = false;
  customDate = null;
  dvErrMsg = "";
  invalidDataview: boolean;
  selectedDataView: string;
  dataViewFilterVisible: boolean;
  dataviewApplied: boolean;
  popoverOpen = false;
  viewBy: string;
  prevViewBy: string;
  @Input() singleSelect: boolean;
  @Input() isNavRevisionFilter: boolean = false;
  @Input() dataView;
  @Input() noYoy?: boolean = false;
  @Input() showReset: boolean;

  @Output() saveDataView = new EventEmitter();
  @Output() getSourcesInfo = new EventEmitter();
  @Output() updateDataCallFlagInMetaInfo = new EventEmitter();
  constructor() {
    this.dataView = {};
  }

  ngOnInit() {
    if (this.noYoy) {
      this.checkOptions = [
        { label: "Values", value: "values", checked: false },
      ];
      if (this.isNavRevisionFilter) {
        this.checkOptions = [
          { label: "Values", value: "values", checked: false },
          { label: "Δ Delta", value: "revision", checked: false },
        ];
      }
    } else {
      this.checkOptions = [
        { label: "Values", value: "values", checked: false },
        { label: "YoY%", value: "yoy", checked: false },
      ];
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.dataView && changes.dataView.currentValue) {
      this.dataView = changes.dataView.currentValue;
      this.viewBy = this.dataView.view_by[0] || "";
      if (this.dataView && this.dataView["view_by"][0] !== "revision") {
        this.radioValue = "";
        if (this.isNavRevisionFilter) {
          if (this.dataView["revision"].startsWith("custom")) {
            this.radioValue = "custom";
            this.customDate = this.dataView["revision"].split("|")[1];
            this.selectedDataView = `Values (${this.customDate})`;
          } else {
            this.radioValue = this.dataView["revision"];
            if (
              this.dataView["revision"] === "today" ||
              this.dataView["revision"] === ""
            ) {
              this.selectedDataView = "Values";
              this.radioValue = "today";
            } else {
              this.selectedDataView =
                this.dataView["revision"][0] === "1"
                  ? `Values (${this.dataView["revision"][0]} month)`
                  : `Values (${this.dataView["revision"][0]} months)`;
            }
          }
        }
        for (let i = 0; i < this.checkOptions.length; i++) {
          this.checkOptions[i].checked = this.dataView["view_by"].includes(
            this.checkOptions[i].value,
          )
            ? true
            : false;
        }
        if (!this.isNavRevisionFilter) {
          if (this.singleSelect) {
            this.selectedDataView =
              this.dataView["view_by"][0] === "values" ? "Values" : "YoY%";
          } else {
            this.selectedDataView = "Values,YoY%";
          }
        }
      } else if (this.dataView["revision"]) {
        if (this.dataView["revision"].startsWith("custom")) {
          this.radioValue = "custom";
          this.customDate = this.dataView["revision"].split("|")[1];
          this.selectedDataView = `&Delta; ${this.customDate}`;
        } else {
          this.radioValue = this.dataView["revision"];
          this.selectedDataView =
            this.dataView["revision"][0] === "1"
              ? `&Delta; ${this.dataView["revision"][0]} month`
              : `&Delta; ${this.dataView["revision"][0]} months`;
        }
      }
      this.prevRadioValue =
        this.radioValue === "custom"
          ? `${this.radioValue}|${this.customDate}`
          : this.radioValue;
      this.prevViewBy = this.viewBy;
    }
  }
  radioValChange() {
    this.checkOptions.map((option) => {
      option.checked = false;
      return { ...option };
    });
    this.viewBy = this.isNavRevisionFilter ? this.viewBy : "revision";
  }

  chkboxOptChange() {
    this.radioValue = this.isNavRevisionFilter ? this.radioValue : "";
    if (this.singleSelect) {
      this.checkOptions.map((option) => {
        option.checked = option.value === this.viewBy;
        return { ...option };
      });
      if (this.viewBy === "revision") {
        this.radioValue = this.radioValue === "today" ? "1m" : this.radioValue;
      }
    }
  }
  onDateChange() {
    if (this.customDate !== null) {
      this.inValidCustomDate = false;
    }
  }
  applyDataView() {
    let viewBy = [];
    if (
      !this.radioValue &&
      !this.checkOptions[0].checked &&
      this.checkOptions[1] &&
      !this.checkOptions[1].checked
    ) {
      this.invalidDataview = true;
      // this.dv  = "Please select a value";
    } else {
      this.invalidDataview = false;
      this.dvErrMsg = "";
      if (this.radioValue !== "") {
        let revision = "";
        let dateStr = "";
        viewBy = ["revision"];
        switch (this.radioValue) {
          case "1m":
            this.inValidCustomDate = false;
            this.selectedDataView = "&Delta; 1 month";
            dateStr = dayjs().subtract(30, "day").format("MM-DD-YYYY");
            revision = `1m`;
            break;
          case "3m":
            this.inValidCustomDate = false;
            this.selectedDataView = "&Delta; 3 months";
            dateStr = dayjs().subtract(90, "day").format("MM-DD-YYYY");
            revision = `3m`;
            break;
          case "custom":
            if (this.customDate === null) this.inValidCustomDate = true;
            else {
              this.inValidCustomDate = false;
              dateStr = dayjs(this.customDate).format("MM-DD-YYYY");
              this.selectedDataView = dateStr;
              revision = `custom|${dateStr}`;
            }
            break;
          default:
            break;
        }
        this.setDataView(revision, viewBy);
      } else {
        this.inValidCustomDate = false;
        //console.log(this.checkOptions);
        if (this.singleSelect) {
          this.checkOptions.forEach((val) => {
            if (val.checked) {
              this.selectedDataView = val.label;
              return;
            }
          });
          this.setDataView("", [
            this.selectedDataView === "Values" ? "values" : "yoy",
          ]);
        } else {
          if (this.checkOptions[0].checked && this.checkOptions[1].checked) {
            this.selectedDataView = "Values,YoY%";
            this.setDataView("", ["values", "yoy"]);
          } else {
            if (this.checkOptions[0].checked) {
              this.selectedDataView = this.checkOptions[0].label;
              this.setDataView("", ["values"]);
            }
            if (this.checkOptions[1].checked) {
              this.selectedDataView = this.checkOptions[1].label;
              this.setDataView("", ["yoy"]);
            }
          }
        }
      }
    }

    //this.inValidCustomDate
  }

  applyNavDataView() {
    const view_by = this.viewBy;
    let rev_date = this.radioValue;
    this.dataView = {
      view_by: [this.viewBy],
      revision: this.radioValue,
    };
    let dateStr = "";
    if (rev_date === "custom") {
      dateStr = dayjs(this.customDate).format("MM-DD-YYYY");
      rev_date = `custom|${dateStr}`;
    }
    if (this.prevViewBy === view_by && this.prevRadioValue === rev_date) {
      this.dataViewFilterVisible = false;
      return;
    }
    const state = {
      prevViewBy: this.prevViewBy,
      prevRevDate: this.prevRadioValue,
      view_by: this.viewBy,
      rev_date: this.radioValue,
      source_updated: false,
    };
    this.updateDataCallFlagInMetaInfo.emit(state);
    if (this.prevViewBy === "revision") {
      if (this.viewBy === "values" && this.radioValue !== "today") {
        this.getSourcesInfo.emit({ view_by, rev_date });
      }
    } else if (this.prevViewBy === "values") {
      if (this.prevRadioValue !== "today") {
        this.getSourcesInfo.emit({ view_by, rev_date });
      } else {
        if (this.viewBy === "values" && this.radioValue !== "today") {
          this.getSourcesInfo.emit({ view_by, rev_date });
        }
      }
    }
    const viewBy = [this.viewBy];
    let revision = "";
    switch (this.radioValue) {
      case "today":
        this.selectedDataView = "Values";
        revision = "";
        break;
      case "1m":
        this.inValidCustomDate = false;
        this.selectedDataView =
          this.viewBy === "revision" ? "&Delta; 1 month" : "Values (1 month)";
        revision = `1m`;
        break;
      case "3m":
        this.inValidCustomDate = false;
        this.selectedDataView =
          this.viewBy === "revision" ? "&Delta; 3 months" : "Values (3 months)";
        revision = `3m`;
        break;
      case "custom":
        if (this.customDate === null) this.inValidCustomDate = true;
        else {
          this.inValidCustomDate = false;
          dateStr = dayjs(this.customDate).format("MM-DD-YYYY");
          this.selectedDataView =
            this.viewBy === "revision"
              ? `&Delta; ${dateStr}`
              : `Values (${dateStr})`;
          revision = `custom|${dateStr}`;
        }
        break;
      default:
        break;
    }
    this.prevRadioValue = revision;
    this.prevViewBy = this.viewBy;
    this.setDataView(revision, viewBy);
  }

  setDataView(revision, viewBy) {
    if (!this.inValidCustomDate) {
      this.dataViewFilterVisible = false;
      this.dataviewApplied = true;
      this.saveDataView.emit({ viewBy, revision });
    }
  }

  disabledCustomDate = (customValue: Date): boolean => {
    return customValue >= dayjs().toDate();
  };
  popoverChange() {
    this.popoverOpen = !this.popoverOpen;
    if (this.popoverOpen) {
      this.dataviewApplied = false;
    }
    if (!this.popoverOpen && !this.dataviewApplied) {
      this.onResetDataView();
    }
  }

  onResetDataView() {
    this.dataViewFilterVisible = false;
    if (this.dataView && this.dataView["view_by"][0] !== "revision") {
      this.radioValue = "";
      for (let i = 0; i < this.checkOptions.length; i++) {
        this.checkOptions[i].checked = this.dataView["view_by"].includes(
          this.checkOptions[i].value,
        )
          ? true
          : false;
      }
      if (this.dataView["view_by"].length < 2) {
        this.selectedDataView =
          this.dataView["view_by"][0] === "values" ? "Values" : "YoY%";
      } else {
        this.selectedDataView = "Values,YoY%";
      }
    } else {
      for (let i = 0; i < this.checkOptions.length; i++) {
        this.checkOptions[i].checked = false;
      }
      if (this.dataView["revision"].startsWith("custom")) {
        this.radioValue = "custom";
        this.customDate = this.dataView["revision"].split("|")[1];
      } else {
        this.radioValue = this.dataView["revision"];
      }
    }
    this.viewBy = this.dataView.view_by[0] || "";
    this.saveDataView.emit({
      viewBy: [this.viewBy],
      revision: this.dataView["revision"] ? this.dataView["revision"] : "",
    });
  }

  onResetDataViewForNav() {
    this.dataViewFilterVisible = false;
    this.viewBy = "values";
    this.radioValue = "today";
    this.selectedDataView = "Values";
    if (this.prevViewBy === "values" && this.prevRadioValue === "today") {
      this.dataViewFilterVisible = false;
      return;
    }
    const state = {
      prevViewBy: this.prevViewBy,
      prevRevDate: this.prevRadioValue,
      view_by: this.viewBy,
      rev_date: this.radioValue,
      source_updated: false,
    };
    this.updateDataCallFlagInMetaInfo.emit(state);
    if (this.prevViewBy === "revision") {
      if (this.viewBy === "values" && this.radioValue !== "today") {
        this.getSourcesInfo.emit({
          view_by: this.viewBy,
          rev_date: this.radioValue,
        });
      }
    } else if (this.prevViewBy === "values") {
      if (this.prevRadioValue !== "today") {
        this.getSourcesInfo.emit({
          view_by: this.viewBy,
          rev_date: this.radioValue,
        });
      } else {
        if (this.viewBy === "values" && this.radioValue !== "today") {
          this.getSourcesInfo.emit({
            view_by: this.viewBy,
            rev_date: this.radioValue,
          });
        }
      }
    }

    this.saveDataView.emit({
      viewBy: [this.viewBy],
      revision: this.radioValue,
    });
  }
}
